// store/index.js
import { createStore } from 'vuex'
import { mutations } from './mutations';
import { actions } from './actions';
import { getters } from './getters'
import createPersistedState from 'vuex-persistedstate';


export default createStore({
  state: {
    address: '',
    balance: '-', //前端获取到的balance，注意users.balance是后端通过接口获取
    invite_code: '',
    kefu: '',
    bsc: '',
    eth: '',
    chain: 'erc', // 默认链，确保存在于 config.CHAIN_LIST 中erc bsc
    lang: 'en', // 默认语言，确保存在于 config.LANG_LIST 中
    users: { balance: '-', leiji: '-' },
    expected: { // 质押相关
      pledge_income: 0, // 质押收益
      liquid_income: 0, // 流动性收益
    },
    token: '',
    walletDetected: false, // 钱包检测状态
    detectedWallets: [] // 检测到的钱包列表
  },
  getters,
  mutations, // 同步方法
  actions, // 异步/同步方法
  modules: {},
  plugins: [
    // 默认将大部分数据存储在 sessionStorage 中
    createPersistedState({
      key: 'session-storage',
      //paths: ['address', 'kefu', 'bsc', 'eth', 'chain', 'users', 'token'], // 只持久化这些字段
      storage: window.sessionStorage // 使用 sessionStorage
    }),
    // lang 使用 localStorage
    createPersistedState({
      key: 'local-storage',
      paths: ['lang', 'token', 'invite_code'], // 只持久化 'lang', 'token' 字段
      storage: window.localStorage // 使用 localStorage
    }),
  ],
})
